import { GlobalToken } from 'antd/es/theme/interface';
import { theme } from 'antd';

export const useGlobalTokenValue = <K extends keyof GlobalToken>(
  tokenKey: K
): GlobalToken[K] => {
  const { token } = theme.useToken();
  return token[tokenKey];
};
